import React from 'react';
import GenelDuyurular from '../Duyuru/GenelDuyurular';
import { Button, Dialog, DialogContent, DialogTitle, Grid } from 'src/components';
import { Breakpoint } from '@mui/system';
import DuyuruKullanimKilavuzu from '../Duyuru/KullanimKilavuzu';
import { translate } from 'src/i18n/tHelper';

interface KullanimKilavuzuLoginProps {
    open?: boolean;
    fullWidth?: boolean;
    maxWidth?: Breakpoint;
    closeHandler?: () => void;
}

const KullanimKilavuzuLogin = (props: KullanimKilavuzuLoginProps) => {
    const closeHandlerClick = (e) => {
        if (props.closeHandler)
            props.closeHandler();
    };
    return (
        <Dialog
            open={props.open}
            fullWidth={props.fullWidth}
            maxWidth={props.maxWidth}
        >
            <DialogTitle>{translate("pages|login", "Kullanım Kılavuzu")}</DialogTitle>
            <DialogContent>
                <Grid container justifyContent="right">
                    <Grid item>
                        <DuyuruKullanimKilavuzu
                            orgTree='ORG.001'
                            height={"500px"}
                            loginControl={true}
                        />
                    </Grid>
                    <Grid item md={4}>
                        <Button customType="close" onClick={closeHandlerClick} />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

export default KullanimKilavuzuLogin;